"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalProductSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const andes_react_1 = require("@yonderland/andes-react");
const ProductDetailV2Container_1 = require("../../../containers/product/ProductDetailV2Container");
const react_redux_1 = require("react-redux");
const AnalyticsActions_creators_1 = require("../../../redux/analytics/actions/AnalyticsActions.creators");
const AdditionalProductSelectorProduct_1 = require("./AdditionalProductSelectorProduct");
const AdditionalProductSelector = ({ additionalProductSelector }) => {
    const { selectedAdditionalProducts, setSelectedAdditionalProducts } = (0, ProductDetailV2Container_1.useProductDetailContext)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { additionalProducts } = additionalProductSelector;
    (0, react_1.useEffect)(() => {
        (additionalProducts === null || additionalProducts === void 0 ? void 0 : additionalProducts.length) > 0 && dispatch(AnalyticsActions_creators_1.analyticsActions.additionalProductSelector(additionalProducts));
    }, [additionalProducts]);
    if ((additionalProducts === null || additionalProducts === void 0 ? void 0 : additionalProducts.length) <= 0) {
        return null;
    }
    const handleSelectionChange = (_event, product) => {
        setSelectedAdditionalProducts(product);
    };
    return ((0, jsx_runtime_1.jsxs)(andes_react_1.StackBlock, { gap: "2", children: [additionalProductSelector.title && (0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { strong: true, children: additionalProductSelector.title }), additionalProducts && ((0, jsx_runtime_1.jsx)(andes_react_1.ResourceList, { testId: "additional_product_selector", items: additionalProducts, hasCheckbox: true, selectable: true, selectedItems: selectedAdditionalProducts, onSelectionChange: handleSelectionChange, renderItem: (additionalProduct, index) => ((0, jsx_runtime_1.jsx)(AdditionalProductSelectorProduct_1.AdditionalProductSelectorProduct, Object.assign({}, additionalProduct), index)) }))] }));
};
exports.AdditionalProductSelector = AdditionalProductSelector;
